import { Add, Remove } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import { useDispatch, useSelector } from "react-redux";
import { getLoanRequirementData, leadGeneration, notify } from "../../API/API";
import { autoLogin, showToast } from "../../components/common/Util/Util";
import SEO from "../../components/SEO";
import { useLeadGeneration } from "../../hooks/useLeadGeneration";
import LoginScreen from "../login/LoginScreen";
import OTPVerification from "../login/OTPVerification";
import RegisterUser from "../login/RegisterUser";
import WelcomeScreen from "../login/WelcomeScreen";
import TalkToAdviser from "../Popups/TalkToAdviser";
import ThankYouPopup from "../Popups/ThankYouPopup";
import CheckEligibilityPopUp from "./CheckEligibilityPopUp";
import EmiCalculator from "./EmiCalculator";

const LoanEligibilityCalculator = ({
  setShowLoginScreen,
  setRedirectToApplyLoan,
}) => {
  const ip = useSelector((state) => state.user.ip);
  const cordinates = useSelector((state) => state.user.cordinates);
  const userData = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(() => {
    const savedTab = localStorage.getItem("calculatorTabIndex");
    return savedTab ? parseInt(savedTab, 10) : 1;
  });
  const [businessAge, setBusinessAge] = useState(0);
  const [entityType, setEntityType] = useState("");
  const [businessType, setBusinessType] = useState("");
  // const [businessType, setBusinessType] = useState("");
  const [totalSales, setTotalSales] = useState(1);
  const [fundsUsed, setFundsUsed] = useState("");
  const [emiHistory, setEmiHistory] = useState("");
  const [annualProfit, setAnnualProfit] = useState(5);
  const [loanRequirementData, setLoanRequirementData] = useState([]);
  const [eligibilityResponse, setEligibilityResponse] = useState([]);
  const [showCheckEligibilityPopup, setShowCheckEligibility] = useState(false);
  const [leadProcessed, setLeadProcessed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerNum, setCustomerNum] = useState("");
  const [entityName, setEntityName] = useState("");
  const [showTalkToAdviser, setShowTalkToAdviser] = useState(false);
  const [showThankYouPopUp, setShowThankYouPopUp] = useState(false);
  const [localShowLoginScreen, setLocalShowLoginScreen] = useState(false);
  const [localRedirectToApplyLoan, setLocalRedirectToApplyLoan] =
    useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showOTPVarification, setShowOTPVarification] = useState(false);
  const [showMobileOTP, setShowMobileOTP] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [requestData, setRequestData] = useState({});
  const setShowLoginScreenFn = setShowLoginScreen || setLocalShowLoginScreen;
  const setRedirectToApplyLoanFn =
    setRedirectToApplyLoan || setLocalRedirectToApplyLoan;
  const handleLeadGeneration = useLeadGeneration(
    setShowTalkToAdviser,
    setShowThankYouPopUp
  );
  const [openIndex, setOpenIndex] = useState(null);
  const [openEligibilityInfo, setOpenEligibilityInfo] = useState(false);

  const handleEligibilityResponse = (response) => {
    setEligibilityResponse(response);
    autoLogin(response, dispatch);
    setLeadProcessed(true);
  };
  const handleCheckEligibilty = () => {
    if (
      entityType !== "" &&
      fundsUsed !== "" &&
      emiHistory !== "" &&
      businessType !== ""
    ) {
      if (
        userData?.MobileNumber ||
        (customerNum !== "" &&
          customerNum?.replace(/-/g, "").length === 10 &&
          entityName !== "")
      ) {
        handlekEligibiltyCheck();
      } else {
        setShowCheckEligibility(true);
      }
    } else {
      showToast("Select all the required field", "error");
    }
  };

  const handleTabChange = (event, tabValue) => {
    setTabIndex(tabValue);
    localStorage.setItem("calculatorTabIndex", tabValue);
  };

  useEffect(() => {
    getLoanRequirementData().then((res) => {
      if (res?.statusCode === 200) setLoanRequirementData(res?.result);
    });
  }, []);

  const handleloanAmount = (amount) => {
    const loanAmount = Number(amount) * 100000;
    return loanAmount.toLocaleString("en-IN");
  };

  const numberToWords = (num) => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const convertLessThanOneThousand = (num) => {
      if (num === 0) return "";
      if (num < 20) return ones[num];
      const ten = Math.floor(num / 10);
      const unit = num % 10;
      return tens[ten] + (unit !== 0 ? " " + ones[unit] : "");
    };

    if (num === 0) return "Zero";

    let result = "";

    if (num >= 10000000) {
      result +=
        convertLessThanOneThousand(Math.floor(num / 10000000)) + " Crore ";
      num %= 10000000;
    }

    if (num >= 100000) {
      result += convertLessThanOneThousand(Math.floor(num / 100000)) + " Lakh ";
      num %= 100000;
    }

    if (num >= 1000) {
      result +=
        convertLessThanOneThousand(Math.floor(num / 1000)) + " Thousand ";
      num %= 1000;
    }

    if (num >= 100) {
      result += convertLessThanOneThousand(Math.floor(num / 100)) + " Hundred ";
      num %= 100;
    }

    if (num > 0) {
      if (result !== "") {
        result += "and ";
      }
      result += convertLessThanOneThousand(num);
    }

    return result.trim();
  };

  const getAmountInWords = (amount) => {
    if (!amount || isNaN(amount)) return "Zero Rupees";

    const loanAmount = Number(amount) * 100000;
    return numberToWords(Math.floor(loanAmount)) + " Rupees";
  };
  const handlekEligibiltyCheck = () => {
    setLoading(true);
    const leadRequest = {
      mobileNumber:
        userData?.MobileNumber?.replace("+91 ", "") ||
        customerNum?.replace(/-/g, ""),
      leadType: "elical",
      ip: ip,
      longitude: String(cordinates?.lng ? cordinates?.lng : ""),
      latitude: String(cordinates?.lat ? cordinates?.lat : ""),
      eliCal: {
        entityType: entityType,
        businessType: businessType,
        businessAge: businessAge,
        totalSales: (totalSales / 100000).toFixed(2),
        annualProfit: (annualProfit / 100000).toFixed(2),
        fundsUsed: fundsUsed,
        emiHistory: emiHistory,
        entityName: userData?.Name || userData?.UserType || entityName,
      },
    };
    leadGeneration(leadRequest)
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 200) {
          setEligibilityResponse(res?.result);
          const notificationRequest = {
            userId: null,
            title: "New Lead Generated",
            content: `A new loan eligibility lead has been generated by ${
              userData?.Name || userData?.name || ""
            }.`,
            createdByRole: "USER",
            type: "leadGeneration",
            action: "View Lead",
            actionUrl: "/leads",
            unread: true,
          };
          notify(notificationRequest);

          autoLogin(res?.result, dispatch);

          setLeadProcessed(true);
        } else {
          showToast(res?.message, "error");
        }
      })
      .catch((err) => {
        console.error("error", err);
        setLoading(false);
      });
  };
  const redirectToApplyLoanTab = () => {
    const isAuthenticated =
      userData?.MobileNumber || localStorage.getItem("jwtToken");

    if (isAuthenticated) {
      window.open("/apply-loan", "_blank");
    } else {
      setRedirectToApplyLoanFn(true);
      setShowLoginScreenFn(true);
    }
  };

  const redirectToContactUs = () => {
    handleLeadGeneration();
  };

  return (
    <>
      <SEO
        title="Business Loan Eligibility Calculator | Dequitec"
        description="Check MSME and unsecured business loan eligibility in seconds. Use Dequitec’s smart calculator to plan funding with accurate and instant results."
        canonical="https://www.dequitec.com/calculator"
      />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="lg" style={{ padding: "16px", marginTop: "1rem" }}>
        <Typography
          variant="h6"
          align="center"
          color="#004AAD"
          fontWeight={700}
          gutterBottom
        >
          Calculators for Eligibility and EMI to Make Financial Planning Easy
        </Typography>
        <Grid>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Tabs
              sx={{
                "& .MuiTab-root": {
                  padding: "18px 20px",
                  minHeight: "10px",
                  marginRight: "5px",
                },
              }}
              value={tabIndex}
              indicatorColor="primary"
              onChange={handleTabChange}
              allowScrollButtonsMobile
              style={{
                borderRadius: "30px",
                marginTop: "10px",
                background: "#EDF0FF",
                marginBottom: "20px",
                alignItems: "center",
                padding: "8px",
                height: "1vh",
              }}
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              <Tab
                disableRipple
                label="Loan Eligibility Calculator"
                value={1}
                style={{
                  minWidth: "16vw",
                  padding: "15px",
                  whiteSpace: "nowrap",
                  borderRadius: "30px",
                  marginLeft: "10px",
                  background: tabIndex === 1 ? "#004AAD" : "transparent",
                  color: tabIndex === 1 ? "#FFF" : "#000",
                  textTransform: "none",
                }}
              />
              <Tab
                disableRipple
                label="EMI Calculator"
                value={2}
                style={{
                  minWidth: "12vw",
                  whiteSpace: "nowrap",
                  borderRadius: "30px",
                  padding: "15px",
                  background: tabIndex === 2 ? "#004AAD" : "transparent",
                  color: tabIndex === 2 ? "#FFF" : "#000",
                  textTransform: "none",
                }}
              />
            </Tabs>
          </div>
        </Grid>
        {tabIndex === 1 && (
          <Grid
            container
            spacing={3}
            style={{ marginTop: "4px", display: "flex", alignItems: "stretch" }}
          >
            <Grid item xs={12} md={7}>
              <Paper
                style={{
                  padding: "24px",
                  backgroundColor: "#F8F8F8",
                  height: "95%",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#000" }}
                  gutterBottom
                >
                  Nature of Entity{" "}
                  <Typography component="span" sx={{ color: "red" }}>
                    *
                  </Typography>
                </Typography>
                <RadioGroup
                  row
                  value={entityType}
                  onChange={(e) => setEntityType(e.target.value)}
                  sx={{ display: "flex", gap: "12px" }}
                >
                  {loanRequirementData?.entity_type?.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      value={item.value}
                      control={
                        <Radio
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "#004AAD",
                            "&.Mui-checked": {
                              color: "#004AAD",
                            },
                          }}
                        />
                      }
                      label={item.value}
                      sx={{
                        margin: 0,
                        padding: "10px 15px",
                        backgroundColor: "#EDF0FF",
                        borderRadius: "8px",
                        fontSize: "0.9rem",
                        fontWeight: "300",
                        color: "#333333",
                        cursor: "pointer",
                        transition: "0.3s",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    />
                  ))}
                </RadioGroup>

                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ marginTop: "24px", color: "#000" }}
                >
                  Nature of Business{" "}
                  <Typography component="span" sx={{ color: "red" }}>
                    *
                  </Typography>
                </Typography>
                <RadioGroup
                  row
                  value={businessType}
                  onChange={(e) => setBusinessType(e.target.value)}
                  sx={{ display: "flex", gap: "12px" }}
                >
                  {loanRequirementData?.business_type?.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      value={item.value}
                      control={
                        <Radio
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "#004AAD",
                            "&.Mui-checked": {
                              color: "#004AAD",
                            },
                          }}
                        />
                      }
                      label={item.value}
                      sx={{
                        margin: 0,
                        padding: "10px 15px",
                        backgroundColor: "#EDF0FF",
                        borderRadius: "8px",
                        fontSize: "0.9rem",
                        fontWeight: "300",
                        color: "#333333",
                        cursor: "pointer",
                        transition: "0.3s",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    />
                  ))}
                </RadioGroup>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    style={{ marginTop: "24px" }}
                  >
                    How old is the business?{" "}
                    <Typography component="span" sx={{ color: "red" }}>
                      *
                    </Typography>
                  </Typography>
                  {/* <Typography
                    variant="subtitle1"
                    gutterBottom
                    style={{ marginTop: "24px" }}
                  >
                    {businessAge === 10 ? "More than 10 Years" : `${businessAge} ${businessAge > 1 ? 'Years' : "Year"}`}
                  </Typography> */}
                  <FormControl
                    sx={{ m: 1, width: "21ch", height: "50px" }}
                    variant="outlined"
                  >
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      // disabled
                      value={businessAge}
                      onChange={(e) => {
                        let value = e.target.value.replace(/,/g, "");
                        const newValue = Number(value);
                        if (!isNaN(newValue) && newValue <= 30) {
                          // setLoanTenure(newValue); // update value without commas
                          setBusinessAge(newValue);
                        }
                      }}
                      inputProps={{
                        maxLength: 2, // just extra safety for browser
                      }}
                      placeholder="E.g., 3 year"
                      startAdornment={
                        <InputAdornment position="start">
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box sx={{ pr: 1, fontWeight: 600 }}>Yrs.</Box>
                            <Divider
                              orientation="vertical"
                              flexItem
                              sx={{
                                height: "40px",
                                bgcolor: "5A5A5A",
                                color: "#5A5A5A",
                              }}
                            />
                          </Box>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Box>
                <Box display="flex" alignItems="center">
                  <Slider
                    value={businessAge}
                    min={0}
                    max={10}
                    step={0.5}
                    onChange={(e, newValue) => setBusinessAge(newValue)}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(value) => `${value} Years`}
                    sx={{
                      marginRight: "16px",
                      color: "#BDBDBD",
                      "& .MuiSlider-thumb": {
                        backgroundColor: "#18CB96",
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#18CB96",
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "#E8E8E8",
                      },
                      "&:active .MuiSlider-track": {
                        backgroundColor: "#18CB96",
                      },
                      height: "8px",
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    style={{ marginTop: "24px" }}
                  >
                    Total Sales of last Financial Year?{" "}
                    <Typography component="span" sx={{ color: "red" }}>
                      *
                    </Typography>
                  </Typography>
                  <FormControl
                    sx={{ m: 1, width: "21ch", height: "50px" }}
                    variant="outlined"
                  >
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      inputProps={{
                        maxLength: 12, // just extra safety for browser
                      }}
                      value={
                        totalSales === 0
                          ? ""
                          : new Intl.NumberFormat("en-IN").format(
                              totalSales.toFixed(0)
                            )
                      }
                      onChange={(e) => {
                        let value = e.target.value.replace(/,/g, "");
                        const newValue = Number(value);
                        if (!isNaN(newValue)) {
                          setTotalSales(newValue); // update value without commas
                        }
                      }}
                      placeholder="E.g., 5,00,000"
                      startAdornment={
                        <InputAdornment position="start">
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box sx={{ pr: 1, fontWeight: 600 }}>INR</Box>
                            <Divider
                              orientation="vertical"
                              flexItem
                              sx={{
                                height: "40px",
                                bgcolor: "5A5A5A",
                                color: "#5A5A5A",
                              }}
                            />
                          </Box>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Box>
                <Box display="flex" alignItems="center">
                  <Slider
                    value={totalSales.toFixed(2)}
                    min={0}
                    max={400000000}
                    step={0.0001}
                    onChange={(e, newValue) => setTotalSales(newValue)}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(value) =>
                      value / 100000 < 100
                        ? `${(value / 100000).toFixed(2)} Lacs`
                        : value / 100000 <= 4000
                        ? `${(value / 10000000).toFixed(2)} Cr`
                        : "More than 40 Cr"
                    }
                    sx={{
                      marginRight: "16px",
                      color: "#BDBDBD",
                      "& .MuiSlider-thumb": {
                        backgroundColor: "#18CB96",
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#18CB96",
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "#E8E8E8",
                      },
                      "&:active .MuiSlider-track": {
                        backgroundColor: "#18CB96",
                      },
                      height: "8px",
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    style={{ marginTop: "24px" }}
                  >
                    Annual profit in Last FY{" "}
                    <Typography component="span" sx={{ color: "red" }}>
                      *
                    </Typography>
                  </Typography>
                  <FormControl
                    sx={{ m: 1, width: "21ch", height: "50px" }}
                    variant="outlined"
                  >
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      inputProps={{
                        maxLength: 12, // just extra safety for browser
                      }}
                      value={
                        annualProfit === 0
                          ? ""
                          : new Intl.NumberFormat("en-IN").format(
                              annualProfit.toFixed(0)
                            )
                      }
                      onChange={(e) => {
                        let value = e.target.value.replace(/,/g, "");
                        const newValue = Number(value);
                        if (!isNaN(newValue)) {
                          setAnnualProfit(newValue); // update value without commas
                        }
                      }}
                      placeholder="E.g., 5,00,000"
                      startAdornment={
                        <InputAdornment position="start">
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box sx={{ pr: 1, fontWeight: 600 }}>INR</Box>
                            <Divider
                              orientation="vertical"
                              flexItem
                              sx={{
                                height: "40px",
                                bgcolor: "5A5A5A",
                                color: "#5A5A5A",
                              }}
                            />
                          </Box>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Box>
                <Box display="flex" alignItems="center">
                  <Slider
                    value={annualProfit}
                    min={0}
                    max={20000000}
                    step={0.001}
                    onChange={(e, newValue) => setAnnualProfit(newValue)}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(value) =>
                      value / 100000 < 100
                        ? `${(value / 100000).toFixed(2)} Lacs`
                        : value / 100000 <= 200
                        ? `${(value / 10000000).toFixed(2)} Cr`
                        : "More than 2 Cr"
                    }
                    sx={{
                      marginRight: "16px",
                      color: "#BDBDBD",
                      "& .MuiSlider-thumb": {
                        backgroundColor: "#18CB96",
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#18CB96",
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "#E8E8E8",
                      },
                      "&:active .MuiSlider-track": {
                        backgroundColor: "#18CB96",
                      },
                      height: "8px",
                    }}
                  />
                </Box>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ marginTop: "24px" }}
                >
                  End use of funds{" "}
                  <Typography component="span" sx={{ color: "red" }}>
                    *
                  </Typography>
                </Typography>
                <RadioGroup
                  row
                  value={fundsUsed}
                  onChange={(e) => setFundsUsed(e.target.value)}
                  sx={{ display: "flex", gap: "12px" }}
                >
                  {loanRequirementData?.funds_used?.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      value={item.value}
                      control={
                        <Radio
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "#004AAD",
                            "&.Mui-checked": {
                              color: "#004AAD",
                            },
                          }}
                        />
                      }
                      label={item.value}
                      sx={{
                        margin: 0,
                        padding: "10px 15px",
                        backgroundColor: "#EDF0FF",
                        borderRadius: "8px",
                        fontSize: "0.9rem",
                        fontWeight: "300",
                        color: "#333333",
                        cursor: "pointer",
                        transition: "0.3s",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    />
                  ))}
                </RadioGroup>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ marginTop: "24px" }}
                >
                  Any history of EMI delay or Default
                  <Typography component="span" sx={{ color: "red" }}>
                    *
                  </Typography>
                </Typography>
                <RadioGroup
                  row
                  value={emiHistory}
                  onChange={(e) => setEmiHistory(e.target.value)}
                  sx={{ display: "flex", gap: "12px", marginBottom: "1rem" }}
                >
                  {loanRequirementData?.emi_history?.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      value={item.value}
                      control={
                        <Radio
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "#004AAD",
                            "&.Mui-checked": {
                              color: "#004AAD",
                            },
                          }}
                        />
                      }
                      label={item?.value}
                      sx={{
                        margin: 0,
                        padding: "10px 15px",
                        backgroundColor: "#EDF0FF",
                        borderRadius: "8px",
                        fontSize: "0.9rem",
                        fontWeight: "300",
                        color: "#333333",
                        cursor: "pointer",
                        transition: "0.3s",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    />
                  ))}
                </RadioGroup>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    color="#004AAD"
                    style={{
                      marginTop: "26px",
                      backgroundColor: "#004AAD",
                      color: "white",
                      textTransform: "none",
                      width: "70%",
                      height: "50px",
                    }}
                    onClick={() => {
                      handleCheckEligibilty();
                    }}
                  >
                    Check Eligibility
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12} md={5}>
              <Box display="flex" flexDirection="column" gap={2}>
                <Paper style={{ padding: "14px", backgroundColor: "#EDF0FF" }}>
                  <Typography
                    variant="subtitle1"
                    color="textSecondary"
                    gutterBottom
                    sx={{ color: "#333333", fontWeight: 600 }}
                  >
                    Your Loan Approval Probability
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    gutterBottom
                    sx={{
                      color: "#5A5A5A",
                      fontStyle: "italic",
                    }}
                  >
                    Based on your financial profile, here's your estimated
                    chance of getting an instant loan approval.
                  </Typography>
                  {/* Speedometer Section */}
                  <Box sx={{ textAlign: "center" }}>
                    <ReactSpeedometer
                      minValue={0}
                      maxValue={97}
                      height={175}
                      width={280}
                      // currentValueText=""
                      value={Math.max(
                        eligibilityResponse?.instantApproval?.score || 0,
                        0
                      )} // Stops at 0 if negative
                      currentValueText={`Score: ${
                        eligibilityResponse?.instantApproval?.score || 0
                      }`} // Shows real score, even if negative
                      needleTransition="easeQuadIn"
                      needleTransitionDuration={1000}
                      needleColor="black"
                      needleHeightRatio={0.4}
                      customSegmentStops={[0, 35, 65, 97]} // Define exact segment stops
                      segmentColors={["#FF4942", "#FFC916", "#A4CD3C"]} // Colors match the segments
                      ringWidth={50}
                      maxSegmentLabels={0}
                      segmentBorderColor="black"
                      segmentBorderWidth={15}
                    />
                  </Box>
                  <Typography
                    variant="body1"
                    align="center"
                    color="#004AAD"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    {!leadProcessed ? (
                      "Fill in all details and check eligibility to see your approval chances"
                    ) : eligibilityResponse?.instantApproval?.score < 35 ? (
                      <>
                        <Box
                          sx={{
                            width: "30px",
                            height: "30px",
                            backgroundColor: "#FF4942",
                            borderRadius: "4px",
                          }}
                        ></Box>
                        We foresee some potential hurdles in the loan approval.
                      </>
                    ) : eligibilityResponse?.instantApproval?.score < 66 ? (
                      <>
                        <Box
                          sx={{
                            width: "30px",
                            height: "30px",
                            backgroundColor: "#FFC916",
                            borderRadius: "4px",
                          }}
                        ></Box>
                        We see a fair opportunity for your loan to be approved.
                      </>
                    ) : (
                      <>
                        <Box
                          sx={{
                            width: "30px",
                            height: "30px",
                            backgroundColor: "#A4CD3C",
                            borderRadius: "4px",
                          }}
                        ></Box>
                        You have a very strong chance of Instant approval.
                      </>
                    )}
                  </Typography>
                </Paper>
                <Paper style={{ padding: "24px", backgroundColor: "#EDF0FF" }}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    sx={{
                      color: "#333333",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    Suggested Loan Products
                    <Tooltip
                      title={
                        <Box sx={{ p: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, mb: 1 }}
                          >
                            Loan Products Full Name
                          </Typography>
                          <Typography variant="body2">
                            OD - Overdraft
                          </Typography>
                          <Typography variant="body2">
                            CC - Cash Credit
                          </Typography>
                          <Typography variant="body2">
                            LAP - Loan Against Property
                          </Typography>
                          <Typography variant="body2">
                            DLOD - Dropline Overdraft
                          </Typography>
                          <Typography variant="body2">
                            BL - Business Loan
                          </Typography>
                          <Typography variant="body2">
                            ML - Machinery Loan
                          </Typography>
                          <Typography variant="body2">
                            EL - Equipment Loan
                          </Typography>
                          <Typography variant="body2">
                            SCF - Supply Chain Finance
                          </Typography>
                          <Typography variant="body2">
                            CGTMSE - Credit Guarantee Fund Trust for Micro and
                            Small Enterprises
                          </Typography>
                        </Box>
                      }
                      arrow
                      placement="right"
                    >
                      <IconButton size="small" sx={{ color: "#004AAD" }}>
                        <InfoIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "#5A5A5A",
                      fontStyle: "italic",
                      marginBottom: "20px",
                    }}
                  >
                    We have shortlisted the best loan products based on your
                    selected purpose and financial details.
                  </Typography>
                  <Box display="flex" flexDirection="column" gap={2}>
                    <Box display="flex" justifyContent={"space-between"}>
                      <Typography
                        sx={{
                          color: "#5A5A5A",
                          fontSize: "0.9rem",
                          paddingY: "6px",
                        }}
                      >
                        Secured Products
                      </Typography>
                      <Typography
                        sx={{
                          color: "#5A5A5A",
                          fontSize: "1rem",
                          backgroundColor: "#B3D1FF",
                          fontWeight: 600,
                          paddingX: "15px",
                          paddingY: "5px",
                          borderRadius: "5px",
                        }}
                      >
                        {
                          eligibilityResponse?.recommendedProducts
                            ?.secured_products
                        }
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent={"space-between"}>
                      <Typography
                        sx={{
                          color: "#5A5A5A",
                          fontSize: "0.9rem",
                          paddingY: "6px",
                        }}
                      >
                        Unsecured Products
                      </Typography>
                      <Typography
                        sx={{
                          color: "#5A5A5A",
                          fontSize: "1rem",
                          backgroundColor: "#B3D1FF",
                          fontWeight: 600,
                          paddingX: "15px",
                          paddingY: "5px",
                          borderRadius: "5px",
                        }}
                      >
                        {
                          eligibilityResponse?.recommendedProducts
                            ?.unsecured_products
                        }
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
                <Paper style={{ padding: "24px", backgroundColor: "#EDF0FF" }}>
                  <Typography
                    variant="subtitle1"
                    color="textSecondary"
                    gutterBottom
                    sx={{ color: "#333333", fontWeight: 600 }}
                  >
                    Estimated Loan Amount
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{
                      color: "#5A5A5A",
                      fontStyle: "italic",
                      marginBottom: "20px",
                    }}
                  >
                    Here's how much loan you may be eligible for based on your
                    business revenue and purpose.
                  </Typography>
                  <Typography
                    variant="h5"
                    align="left"
                    style={{
                      fontWeight: 700,
                      fontSize: "1.5rem",
                      color: "#FF9500",
                      marginTop: "15px",
                      marginBottom: "10px",
                    }}
                  >
                    ₹{" "}
                    {handleloanAmount(
                      eligibilityResponse?.eligibleAmount?.loanAmount || 0
                    )}
                  </Typography>
                  <Typography
                    variant="body1"
                    align="left"
                    style={{
                      color: "#5A5A5A",
                      fontWeight: 500,
                      marginBottom: "15px",
                    }}
                  >
                    {(eligibilityResponse?.eligibleAmount?.loanAmount || 0) >
                      0 &&
                      `${getAmountInWords(
                        eligibilityResponse?.eligibleAmount?.loanAmount || 0
                      )} (Amount in words)`}
                  </Typography>
                  {(eligibilityResponse?.eligibleAmount?.loanAmount || 0) >
                    0 && (
                    <Typography
                      variant="body1"
                      align="left"
                      style={{
                        color: "#5A5A5A",
                        fontWeight: "bolder",
                        fontSize: 12,
                        marginBottom: "15px",
                      }}
                    >
                      *Assumption: Proposed Loan amount is long-term in nature,
                      repayable in{" "}
                      <span style={{ color: "#FF9500" }}>7 years.</span>
                    </Typography>
                  )}
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    {(eligibilityResponse?.eligibleAmount?.loanAmount || 0) >
                      0 && (
                      <Button
                        variant="contained"
                        color="#004AAD"
                        style={{
                          marginTop: "16px",
                          backgroundColor: "#004AAD",
                          color: "white",
                          textTransform: "none",
                          width: "70%",
                          height: "50px",
                        }}
                        onClick={redirectToApplyLoanTab}
                      >
                        Apply Loan Now
                      </Button>
                    )}
                  </Box>
                  <Typography
                    variant="body2"
                    align="center"
                    style={{
                      marginTop: "16px",
                      color: "#004AAD",
                      marginBottom: "1.5rem",
                      cursor: "pointer",
                    }}
                    onClick={redirectToContactUs}
                  >
                    Need Customized Solution?
                  </Typography>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        )}
        {tabIndex === 2 && (
          <EmiCalculator
            redirectToApplyLoanTab={redirectToApplyLoanTab}
            setShowTalkToAdviser={setShowTalkToAdviser}
            setShowThankYouPopUp={setShowThankYouPopUp}
          />
        )}
        {tabIndex === 1 && leadProcessed && (
          <>
            <Typography
              align="center"
              color="#18CB96"
              style={{ marginTop: "32px", fontWeight: 900, fontSize: "32px" }}
            >
              Congratulations!
            </Typography>
            <Typography
              variant="h6"
              align="center"
              color="textSecondary"
              style={{ marginTop: "2px", color: "#777777", fontWeight: 600 }}
            >
              You Are Eligible for a lending amount of{" "}
              <span style={{ fontWeight: 800, color: "#004AAD" }}>
                ₹
                {handleloanAmount(
                  eligibilityResponse?.eligibleAmount?.loanAmount || 0
                )}
              </span>
            </Typography>

            <Box
              sx={{
                backgroundColor: "#F8F9FA",
                padding: "20px 40px",
                borderRadius: "10px",
                maxWidth: "85%",
                margin: "30px auto",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#004AAD",
                  marginBottom: "15px",
                  borderBottom: "1px solid #E0E0E0",
                  paddingBottom: "10px",
                }}
              >
                You are now close to achieving your funding requirement with the
                'Quick Loan' for the mentioned loan amount.
              </Typography>

              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  color: "#333333",
                  marginBottom: "15px",
                }}
              >
                Experience our Disbursement process with the following benefits:
              </Typography>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                  gap: "10px 30px",
                  marginLeft: "10px",
                }}
              >
                {[
                  "Complete Online Process",
                  "Minimal Documentation",
                  "Quick Disbursement",
                  "Competitive Interest Rates",
                  "Flexible Repayment Options",
                  "Dedicated Relationship Manager",
                  "Customized Loan Solutions",
                  "Transparent Process",
                  "24/7 Customer Support",
                ].map((benefit, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <Box
                      sx={{
                        width: "8px",
                        height: "8px",
                        backgroundColor: "#18CB96",
                        borderRadius: "50%",
                      }}
                    />
                    <Typography sx={{ color: "#555555", fontSize: "0.9rem" }}>
                      {benefit}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: 600,
                  color: "#004AAD",
                  marginTop: "20px",
                  backgroundColor: "#E5EEFF",
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                Apply Now and get your loan approved in minutes!
              </Typography>

              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "0.9rem",
                  color: "#666666",
                  marginTop: "15px",
                }}
              >
                For any queries, contact our support team at{" "}
                <span style={{ color: "#004AAD", fontWeight: 500 }}>
                  support@loanprovider.com
                </span>
              </Typography>
            </Box>
          </>
        )}
        {showCheckEligibilityPopup && (
          <CheckEligibilityPopUp
            showCheckEligibilityPopup={showCheckEligibilityPopup}
            setShowCheckEligibility={setShowCheckEligibility}
            setEligibilityResponse={handleEligibilityResponse}
            businessAge={businessAge}
            businessType={businessType}
            emiHistory={emiHistory}
            annualProfit={annualProfit}
            totalSales={totalSales}
            entityType={entityType}
            fundsUsed={fundsUsed}
            setCustomerNum={setCustomerNum}
            customerNum={customerNum}
            setEntityName={setEntityName}
            entityName={entityName}
          />
        )}
        {showTalkToAdviser && (
          <TalkToAdviser
            showTalkToAdviser={showTalkToAdviser}
            setShowTalkToAdviser={setShowTalkToAdviser}
            setShowThankYouPopUp={setShowThankYouPopUp}
          />
        )}
        {showThankYouPopUp && (
          <ThankYouPopup
            showThankYouPopUp={showThankYouPopUp}
            setShowThankYouPopUp={setShowThankYouPopUp}
            from="LoanEligibilityCalculator"
          />
        )}
        <Box
          sx={{
            marginTop: "40px",
            marginBottom: "48px",
            px: { xs: "24px", sm: "32px", md: "40px" },
            maxWidth: "1000px",
            mx: "auto",
            position: "relative",
            "&::before, &::after": {
              content: '""',
              position: "absolute",
              width: { xs: "200px", md: "400px" },
              height: { xs: "200px", md: "400px" },
              borderRadius: "50%",
              opacity: 0.05,
              zIndex: -1,
            },
            "&::before": {
              top: "-100px",
              left: "-100px",
              background: "#004AAD",
              filter: "blur(60px)",
            },
            "&::after": {
              bottom: "-100px",
              right: "-100px",
              background: "#18CB96",
              filter: "blur(60px)",
            },
          }}
        >
          <Box sx={{ mb: 8 }}>
            <Box
              sx={{
                textAlign: "center",
                mb: 4,
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "#1A1A1A",
                  fontWeight: 700,
                  fontSize: { xs: "24px", sm: "28px", md: "32px" },
                  lineHeight: 1.4,
                }}
              >
                Check Your Business Loan Eligibility Instantly
              </Typography>
            </Box>
            <Box
              sx={{
                borderRadius: "12px",
                backgroundColor: "#FFFFFF",
                border: "1px solid",
                borderColor: openEligibilityInfo ? "#004AAD" : "#E5E5E5",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                overflow: "hidden",
                boxShadow: openEligibilityInfo
                  ? "0px 8px 30px rgba(0, 74, 173, 0.12)"
                  : "0px 2px 4px rgba(0, 0, 0, 0.05)",
                transform: openEligibilityInfo ? "translateY(-2px)" : "none",
                "&:hover": {
                  borderColor: "#004AAD",
                  boxShadow: "0px 8px 30px rgba(0, 74, 173, 0.12)",
                  transform: "translateY(-2px)",
                },
              }}
            >
              <Box
                onClick={() => setOpenEligibilityInfo(!openEligibilityInfo)}
                sx={{
                  padding: "28px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: openEligibilityInfo
                    ? "linear-gradient(45deg, rgba(0, 74, 173, 0.02), rgba(24, 203, 150, 0.02))"
                    : "#FFFFFF",
                  borderBottom: openEligibilityInfo
                    ? "1px solid rgba(0, 74, 173, 0.1)"
                    : "none",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                <Typography
                  sx={{
                    color: openEligibilityInfo ? "#004AAD" : "#2D3748",
                    fontWeight: 600,
                    fontSize: { xs: "16px", sm: "17px" },
                    lineHeight: 1.5,
                    transition: "all 0.3s ease",
                    flex: 1,
                    pr: 3,
                  }}
                >
                  Check Your Business Loan Eligibility Instantly
                </Typography>
                <Box
                  sx={{
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                    backgroundColor: openEligibilityInfo
                      ? "#E5EEFF"
                      : "#F8F9FA",
                    color: openEligibilityInfo ? "#004AAD" : "#718096",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    transform: openEligibilityInfo
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    "&:hover": {
                      backgroundColor: "#E5EEFF",
                      color: "#004AAD",
                    },
                  }}
                >
                  {openEligibilityInfo ? (
                    <Remove
                      sx={{
                        fontSize: "20px",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      }}
                    />
                  ) : (
                    <Add
                      sx={{
                        fontSize: "20px",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      }}
                    />
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  maxHeight: openEligibilityInfo ? "5000px" : "0px",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  overflow: "hidden",
                  opacity: openEligibilityInfo ? 1 : 0,
                  transform: openEligibilityInfo
                    ? "translateY(0)"
                    : "translateY(-12px)",
                  background:
                    "linear-gradient(180deg, rgba(0, 74, 173, 0.02) 0%, rgba(24, 203, 150, 0.02) 100%)",
                }}
              >
                <Box sx={{ padding: "28px" }}>
                  <Typography sx={{ color: "#4A5568", mb: 3, lineHeight: 1.8 }}>
                    Curious about how much money your business can get? With
                    DeQuitec’s business loan eligibility checker, you don’t have
                    to wonder. In a matter of a few clicks, you can learn how
                    much money your business could potentially get with no
                    paperwork, no waiting.
                  </Typography>
                  <Typography sx={{ color: "#4A5568", mb: 4, lineHeight: 1.8 }}>
                    It’s fast, simple, and free.
                  </Typography>

                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h6"
                      sx={{ color: "#004AAD", fontWeight: 700, mb: 1 }}
                    >
                      Why Use the Eligibility Calculator?
                    </Typography>
                    <Typography sx={{ color: "#4A5568", mb: 1 }}>
                      Before you apply for any loan, it helps to know your
                      chances. The business loan eligibility calculator gives
                      you a quick and clear picture of:
                    </Typography>
                    <Box sx={{ pl: 2 }}>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • How much loan amount can you expect?
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • What is your cash credit limit for a small business?
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Possible interest rates and repayment terms
                      </Typography>
                    </Box>
                    <Typography sx={{ color: "#4A5568", mt: 1 }}>
                      This way, you can plan and apply confidently.
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h6"
                      sx={{ color: "#004AAD", fontWeight: 700, mb: 1 }}
                    >
                      How It Works – Step by Step
                    </Typography>
                    <Typography
                      sx={{ color: "#4A5568", lineHeight: 1.8, mb: 1 }}
                    >
                      <strong>Fill in basic details.</strong> Just enter your
                      business info like turnover, years in operation, and
                      existing loans. No deep financials or collateral details
                      required.
                    </Typography>
                    <Typography
                      sx={{ color: "#4A5568", lineHeight: 1.8, mb: 1 }}
                    >
                      <strong>Run the calculator.</strong> Based on what you
                      enter, the tool will calculate your estimated loan
                      eligibility using smart matching with lender criteria.
                    </Typography>
                    <Typography
                      sx={{ color: "#4A5568", lineHeight: 1.8, mb: 1 }}
                    >
                      <strong>See your results instantly.</strong>
                    </Typography>
                    <Box sx={{ pl: 2 }}>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • How much you might qualify for
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Your potential cash credit limit
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Loan terms such as interest rates and repayment period
                      </Typography>
                    </Box>
                    <Typography
                      sx={{ color: "#4A5568", lineHeight: 1.8, mt: 1 }}
                    >
                      <strong>Get expert help.</strong> One of our advisors will
                      reach out to explain the results, answer your questions,
                      and help you move forward.
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h6"
                      sx={{ color: "#004AAD", fontWeight: 700, mb: 1 }}
                    >
                      What Does the Calculator Look At?
                    </Typography>
                    <Typography sx={{ color: "#4A5568", mb: 1 }}>
                      The tool considers important factors that lenders use,
                      like:
                    </Typography>
                    <Box sx={{ pl: 2 }}>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Your business revenue or cash flow
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Credit score and repayment history
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Time in business
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Your current debt (if any)
                      </Typography>
                    </Box>
                    <Typography sx={{ color: "#4A5568", mt: 1 }}>
                      Based on this, it gives you an idea of how much credit you
                      can get either as a one-time loan or as a cash credit
                      limit for a small business, which acts like a flexible
                      credit line you can use when needed.
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h6"
                      sx={{ color: "#004AAD", fontWeight: 700, mb: 1 }}
                    >
                      Benefits of Checking Eligibility
                    </Typography>
                    <Box sx={{ pl: 2 }}>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • No surprises – You’ll know where you stand before you
                        apply.
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Better planning – Understand how much funding you can
                        work with
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Faster processing – Your advisor can quickly match you
                        with the right lender
                      </Typography>
                      <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                        • Saves time – Avoid going through lengthy processes
                        with lenders who may not fit
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h6"
                      sx={{ color: "#004AAD", fontWeight: 700, mb: 1 }}
                    >
                      Who Can Use It?
                    </Typography>
                    <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                      Any business owner, whether you run a shop, salon,
                      consultancy, or startup, can use the tool. Even if you’re
                      just getting started or don’t have audited financials, the
                      calculator still gives you a useful estimate.
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      variant="h6"
                      sx={{ color: "#004AAD", fontWeight: 700, mb: 1 }}
                    >
                      Curious how much funding your business can get?
                    </Typography>
                    <Typography sx={{ color: "#4A5568", lineHeight: 1.8 }}>
                      Try our business loan eligibility calculator. It’s quick,
                      simple, and free. Find out your loan options in minutes,
                      and if you have questions, our team is here to help.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              textAlign: "center",
              mb: 8,
              position: "relative",
            }}
          >
            <Typography
              component="span"
              sx={{
                color: "#004AAD",
                fontSize: "14px",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "3px",
                display: "block",
                marginBottom: "16px",
              }}
            >
              EXPLORE OUR
            </Typography>
            <Typography
              variant="h4"
              sx={{
                color: "#1A1A1A",
                fontWeight: 700,
                fontSize: { xs: "28px", sm: "32px", md: "36px" },
                lineHeight: 1.4,
                marginBottom: "40px",
                fontFamily: "Open Sans",
                position: "relative",
                display: "inline-block",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-16px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "80px",
                  height: "4px",
                  background: "linear-gradient(90deg, #004AAD, #18CB96)",
                  borderRadius: "2px",
                },
              }}
            >
              Loan Products and Process
            </Typography>
            <Typography
              sx={{
                color: "#666666",
                maxWidth: "600px",
                margin: "0 auto",
                fontSize: { xs: "15px", sm: "16px" },
                lineHeight: 1.6,
                mt: 4,
              }}
            >
              Find comprehensive answers to common questions about our loan
              services and processes
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              maxWidth: "850px",
              margin: "0 auto",
              position: "relative",
            }}
          >
            {[
              {
                question:
                  "How does Dequitec’s business loan eligibility checker work?",
                answer:
                  "It’s a quick tool that helps you understand how much funding your business might qualify for based on basic details like revenue, time in business, and existing loans.",
              },
              {
                question:
                  "What information do I need to use the business loan eligibility calculator?",
                answer:
                  "Just your business turnover, how long you've been operating, and any current loans. No documents or uploads needed.",
              },
              {
                question:
                  "Can the calculator help me determine the cash credit limit for my small business?",
                answer:
                  "Yes, it gives an estimate of how much working capital or cash credit your business could get based on your finances.",
              },
              {
                question:
                  "How accurate is the business loan eligibility calculator on Dequitec?",
                answer:
                  "It gives a close estimate based on real lending criteria, but the final loan amount may vary after document checks and approval.",
              },
              {
                question:
                  "Why should I use a business loan eligibility checker before applying for a loan?",
                answer:
                  "It saves time and helps you apply for the right loan with confidence, reducing the chances of rejection.",
              },
              {
                question:
                  "Does the calculator also estimate eligibility for MSME and startup loans?",
                answer:
                  "Yes, it works for MSMEs, startups, and even newer businesses with limited financial history.",
              },
              {
                question:
                  "What factors affect the cash credit limit for small businesses?",
                answer:
                  "Your turnover, monthly income, expenses, existing loans, and credit score all play a role.",
              },
              {
                question:
                  "Can I use the eligibility checker for both secured and unsecured loans?",
                answer:
                  "Yes, the tool supports both. It shows you options based on your profile, whether you have collateral or not.",
              },
              {
                question:
                  "How does Dequitec simplify business loan eligibility calculations for entrepreneurs?",
                answer:
                  "It’s quick, digital, and free. You get instant results without any hassle, and you can talk to an expert if needed.",
              },
              {
                question:
                  "Will using the calculator affect my credit score or loan application?",
                answer:
                  "No. It’s a soft check that doesn’t impact your credit score in any way.",
              },
            ].map((faq, index) => (
              <Box
                key={index}
                sx={{
                  borderRadius: "12px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid",
                  borderColor: openIndex === index ? "#004AAD" : "#E5E5E5",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  overflow: "hidden",
                  boxShadow:
                    openIndex === index
                      ? "0px 8px 30px rgba(0, 74, 173, 0.12)"
                      : "0px 2px 4px rgba(0, 0, 0, 0.05)",
                  transform: openIndex === index ? "translateY(-2px)" : "none",
                  "&:hover": {
                    borderColor: "#004AAD",
                    boxShadow: "0px 8px 30px rgba(0, 74, 173, 0.12)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Box
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                  sx={{
                    padding: "28px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor:
                      openIndex === index
                        ? "linear-gradient(45deg, rgba(0, 74, 173, 0.02), rgba(24, 203, 150, 0.02))"
                        : "#FFFFFF",
                    borderBottom:
                      openIndex === index
                        ? "1px solid rgba(0, 74, 173, 0.1)"
                        : "none",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                >
                  <Typography
                    sx={{
                      color: openIndex === index ? "#004AAD" : "#2D3748",
                      fontWeight: 600,
                      fontSize: { xs: "16px", sm: "17px" },
                      lineHeight: 1.5,
                      transition: "all 0.3s ease",
                      flex: 1,
                      pr: 3,
                    }}
                  >
                    {faq.question}
                  </Typography>
                  <Box
                    sx={{
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "8px",
                      backgroundColor:
                        openIndex === index ? "#E5EEFF" : "#F8F9FA",
                      color: openIndex === index ? "#004AAD" : "#718096",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      transform:
                        openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                      "&:hover": {
                        backgroundColor: "#E5EEFF",
                        color: "#004AAD",
                      },
                    }}
                  >
                    {openIndex === index ? (
                      <Remove
                        sx={{
                          fontSize: "20px",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                      />
                    ) : (
                      <Add
                        sx={{
                          fontSize: "20px",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                      />
                    )}
                  </Box>
                </Box>
                <Box
                  sx={{
                    maxHeight: openIndex === index ? "2000px" : "0px",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    overflow: "hidden",
                    opacity: openIndex === index ? 1 : 0,
                    transform:
                      openIndex === index
                        ? "translateY(0)"
                        : "translateY(-12px)",
                    background:
                      "linear-gradient(180deg, rgba(0, 74, 173, 0.02) 0%, rgba(24, 203, 150, 0.02) 100%)",
                  }}
                >
                  <Typography
                    sx={{
                      padding: "28px",
                      color: "#4A5568",
                      fontSize: { xs: "15px", sm: "16px" },
                      lineHeight: 1.8,
                      whiteSpace: "pre-line",
                      borderTop: "1px solid rgba(0, 74, 173, 0.1)",
                      "& li, & bullet": {
                        marginBottom: "12px",
                        position: "relative",
                        paddingLeft: "20px",
                        "&::before": {
                          content: '"•"',
                          position: "absolute",
                          left: 0,
                          color: "#004AAD",
                          fontWeight: "bold",
                          fontSize: "18px",
                          top: "-2px",
                        },
                      },
                    }}
                  >
                    {faq.answer}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
        {/* <NextStepCard /> */}
      </Container>
      {localShowLoginScreen && (
        <LoginScreen
          showLoginScreen={localShowLoginScreen}
          setShowLoginScreen={setLocalShowLoginScreen}
          setShowRegister={setShowRegister}
          setShowOTPVarification={setShowOTPVarification}
          setShowMobileOTP={setShowMobileOTP}
          setRequestData={setRequestData}
          requestData={requestData}
        />
      )}
      {showRegister && (
        <RegisterUser
          showRegister={showRegister}
          setShowRegister={setShowRegister}
          setShowLoginScreen={setLocalShowLoginScreen}
          setShowOTPVarification={setShowOTPVarification}
          setRequestData={setRequestData}
          requestData={requestData}
          setShowMobileOTP={setShowMobileOTP}
        />
      )}
      {showOTPVarification && (
        <OTPVerification
          key={`otp-verification-${new Date().getTime()}`}
          showOTPVarification={showOTPVarification}
          setShowOTPVarification={setShowOTPVarification}
          showMobileOTP={showMobileOTP}
          setShowWelcome={setShowWelcome}
          setRequestData={setRequestData}
          requestData={requestData}
          redirectToApplyLoan={localRedirectToApplyLoan}
        />
      )}
      {showWelcome && (
        <WelcomeScreen
          showWelcome={showWelcome}
          setShowWelcome={setShowWelcome}
          requestData={requestData}
          redirectToApplyLoan={localRedirectToApplyLoan}
        />
      )}
    </>
  );
};

export default LoanEligibilityCalculator;
